import { app } from '../../../../../../app';

app.component('companyUserDirectoriesManageUserAddAccountAccountAlreadyExists', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./account-already-exists.html')
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/add-account/account-already-exists/account-already-exists.component.js